<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-cube-outline"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row class="mr-4">
        <v-col class="white rounded-lg" cols="8">
          <v-col cols="12">
            <v-text-field
                v-model="tech.name"
                filled
                label="Tên"
                placeholder="Nhập tên"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
                v-model="tech.description"
                filled
                label="Mô tả"
                placeholder="Nhập mô tả"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-file-input
                label="Ảnh "
                placeholder="Tải ảnh lên"
                prepend-icon="mdi-camera"
                v-model="image"
                @change="uploadImg"
            ></v-file-input>
            <div v-if="display_image">
              <v-img
                  :src="display_image"
                  aspect-ratio="1.7"
                  contain
                  width="200"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn
                color="primary"
                width="180"
                @click="save()"
            >
              Lưu
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import {UPLOAD_IMAGE} from "@/store/modules/field_project";
import {SAVE_TECHNOLOGY} from "@/store/modules/technology";

export default {
  name: "Addnew_tech",
  data(){
    return{
      page: "Thêm technology",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách technology",
          disabled: true,
        },
        {
          text: "Thêm technology",
          disabled: false,
        },
      ],
      image: null,
      display_image: '',

      tech:{
        name:'',
        description:'',
        active:0,
        photo_url:''
      }
    }
  },
  methods:{

    uploadImg(e) {
      if (e) {
        this.display_image = URL.createObjectURL(e)
      }
      this.$forceUpdate()
    },
    async save() {
      let formDateAvatar = new FormData();
      formDateAvatar.append("upload", this.image);
      formDateAvatar.append("type", "ckeditor");
      formDateAvatar.append("position_type", "1");
      await this.$store.dispatch(`${UPLOAD_IMAGE}`, formDateAvatar).then((data) => {
            if (data.data.status == 1) {
              this.tech.photo_url = data.data.data[0].path
            }
          }
      )
      let data = {
        name: this.tech.name,
        description: this.tech.description,
        photo_url: this.tech.photo_url,
        active: this.tech.active
      }
      await this.$store.dispatch(`${SAVE_TECHNOLOGY}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/technology')
        }
      });
    }
  }
}
</script>

<style scoped>

</style>